export default "/images/0f79194761cfbb0fcb58467f1c7a335a.avif";